import React from "react";
import Slider from "react-slick";

export default function HomeChoose({ data, sectionClass }) {
  const { title, subtitle, items } = data;

  const settingskey = {
    autoplay: true,
    speed: 4000,
    infinite: true,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 99999,
        settings: "unslick",
      },
    ],
  };

  return (
    <>
      <section className={`homechoose ${sectionClass || ""}`} >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="services-text">
                <h2 className="heading">{title}</h2>
                <p>{subtitle}</p>
              </div>
            </div>
          </div>
          <div className="choose-row-wraps">
              <Slider {...settingskey}  className="choose-row key-slides row" >
              {items?.map((item, index) => (
                <div className="choose-cols col-md-6 col-lg-4" key={index}>
                  <div className="choose-cols-inner">
                    <div className="icon">
                      <img src={item.icon} alt={item.title} className="img-responsive" loading="lazy" />
                    </div>
                    <div className="choose-content">
                      <div className="heading">{item.title}</div>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
              </Slider>
            
          </div>
        </div>
      </section>
    </>

  );
}
